// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"7088aa5a","115":"1c64fd3e","172":"87979f26","234":"14dfc2c4","235":"ebb1c610","356":"0ea0f0c4","359":"4437a089","511":"5d27a8af","592":"2dd1a946","632":"d7e57b22","696":"d80a270b","739":"a5a1722c","853":"2365565f","880":"90fe9712","995":"116a2895"}[chunkId] + ".chunk.js";
};